<script setup lang="ts">
import type { Locale } from "~ui/utils/locales"

const { locale, size = "md" } = defineProps<{
  locale: Locale
  size?: "sm" | "md" | "lg"
}>()

// Map locales to their corresponding flag components
const localeToFlagMap: Record<Locale, ReturnType<typeof resolveComponent>> = {
  da_DK: resolveComponent("SvgoDanish"),
  en_US: resolveComponent("SvgoEnglish"),
  de_DE: resolveComponent("SvgoGerman"),
  nb_NO: resolveComponent("SvgoNorwegian"),
  sv_SE: resolveComponent("SvgoSwedish"),
  pt_PT: resolveComponent("SvgoPortugese"),
  fi_FI: resolveComponent("SvgoFinish"),
  pl_PL: resolveComponent("SvgoPolish"),
  nl_NL: resolveComponent("SvgoDutch"),
} as const

// Get the correct flag component based on the locale
const flagComponent = computed(() => {
  return localeToFlagMap[locale] ?? resolveComponent("SvgoEnglish")
})
const sizeClass = computed(() => {
  if (size == "sm") {
    return "size-3.5"
  } else if (size == "md") {
    return "size-5"
  } else {
    return "size-7"
  }
})
</script>

<template>
  <component :is="flagComponent" :class="sizeClass" data-testid="locale-flag" />
</template>
